
// Importando as dependências
import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import translations from '../../i18n/locales'

// Configuração i18n
const i18nConfig = {
  resources: translations,
  fallbackLng: 'pt-BR',
  defaultNS: 'translations',
  detection: {
    order: ['path', 'navigator'],
  }
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init(i18nConfig)

const languagesAllowed = Object.keys(translations);
export { languagesAllowed }
export default i18n